<template>
  <div>
    <b-alert variant="secondary" show>
      <div
        style="display: flex; align-items: end; justify-content: end"
        class="mb-1 alert-heading"
      >
        <p class="mr-1 no-wrap"><b>Account Receivable (to date) :</b></p>
        <div style="width:450px;">
          <flat-pickr
          @input="onReportDate"
          v-model="reportToDate"
          :config="{ ...$flatPickrConfig, max: new Date() }"
          placeholder="Select Month Range"          
          />
        </div>
        <b-form-checkbox
          v-model="showTotal"
          name="check-button"
          inline
          class="ml-1"
          style="width: 10%; text-align: left"
        >
          <b><u>Show Total</u></b>
        </b-form-checkbox>
        <b-form-checkbox
          v-model="filters.show_paid_invoice"
          name="check-button"
          inline
          class="ml-1"
          style="width: 25%; text-align: right"
          @change="onApplyFilters"
        >
          <b><u>Show Paid Invoice</u></b>
        </b-form-checkbox>

        <b-button
          @click="showModal"
          class="mr-1"
          v-b-tooltip.hover
          title="apply filters"
          variant="secondary"
          size="sm"
          ><feather-icon style="cursor: pointer" icon="FilterIcon" size="23"
        /></b-button>
        <b-button
          v-b-tooltip.hover
          title="export as excel"
          variant="secondary"
          size="sm"
          class="mr-1"
          @click="onExportExcel"
          ><feather-icon style="cursor: pointer" icon="DownloadIcon" size="23"
        /></b-button>
        <div style="display: flex; justify-content: flex-end">
          <b-button variant="secondary" @click="handleResetButtonClicked"
            >Reset</b-button
          >
        </div>
      </div>
    </b-alert>
    <div v-if="filterApplied == true" style="margin-top: 2%; margin-bottom:2%">
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvoiceArray.length > 0"
      >
        Invoice No : {{ appliedFilters.selectedInvoiceArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedaccArray.length > 0"
      >
        Account No : {{ appliedFilters.selectedaccArray.toString() }}
      </b-badge>

      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedLicensorArray.length > 0"
      >
        Licensor : {{ appliedFilters.selectedLicensorArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvDateRange"
      >
        Invoice Date : {{ appliedFilters.selectedInvDateRange }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedCurrencyArray.length > 0"
      >
        Invoice Currency : {{ appliedFilters.selectedCurrencyArray.toString() }}
      </b-badge>
    </div>
    <div style="overflow-x: auto">
      <table ref="exportable_table">
        <tr style="background: lightgrey">
          <th>
            Invoice Number
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Account
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Licensor
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Invoice Date
            <!-- <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="warning"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button> -->
          </th>
          <th>
            Invoice Currency
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th style="border-left: 2.5px solid grey">Invoice Amount CHF</th>
          <th>Unpaid Amount CHF</th>
          <th style="border-right: 2.5px solid grey">Paid Amount CHF</th>
          <th>Invoice Amount EUR</th>

          <th>Unpaid Amount EUR</th>
          <th style="border-right: 2.5px solid grey">Paid Amount EUR</th>
          <th>Invoice Amount USD</th>
          <th>Unpaid Amount USD</th>
          <th>Paid Amount USD</th>
          <th>Exchange Rate</th>
          <th>Final Unpaid (CHF)</th>
        </tr>
        <tr
          v-for="(item, index) in filteredAccountReceivableReportData"
          :key="index"
          :style="
            item.invoice_unique_id == 'Total'
              ? 'background:lightGrey;border-bottom:2.5px solid grey '
              : ''
          "
        >
          <td>
            <a
              @click="
                () =>
                  (invId = item.revenue_invoice_id
                    ? item.revenue_invoice_id
                    : null)
              "
              v-b-modal.invModal
              ><u>{{ item.invoice_unique_id }}</u></a
            >
          </td>
          <td>{{ item.iban }}</td>
          <td>{{ item.company }}</td>
          <td>
            {{ item.invoiceDate ? item.invoiceDate : "" }}
          </td>
          <td>{{ item.selectedCurrency }}</td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="border-left: 2.5px solid grey"
          >
            {{ formatCurrency(item.total_amt_chf) }}
          </td>

          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right;"
          >
            {{ formatCurrency(item.unpaid_amt_chf) }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right; border-right: 2.5px solid grey"
          >
            {{ formatCurrency(item.paid_amt_chf) }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right"
          >
            {{ formatCurrency(item.total_amt_eur) }}
          </td>

          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right;"
          >
            {{ formatCurrency(item.unpaid_amt_eur) }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right; border-right: 2.5px solid grey"
          >
            {{ formatCurrency(item.paid_amt_eur) }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right"
          >
            {{ formatCurrency(item.total_amt_usd) }}
          </td>

          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right"
          >
            {{ formatCurrency(item.unpaid_amt_usd) }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right"
          >
            {{ formatCurrency(item.paid_amt_usd) }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right"
          >
            {{ item.exchange_rate ? formatExchangeRate(item.exchange_rate) : 1 }}
          </td>
          <td
            :style="
              !item.selectedCurrency
                ? 'text-align: right; background: lightGrey'
                : 'text-align: right;'
            "
            style="text-align: right"
          >
            {{ formatCurrency(item.unpaid_in_base_chf) }}
          </td>
        </tr>
      </table>
    </div>
    <div>
      <b-modal
        no-close-on-backdrop
        ref="my-modal"
        hide-footer
        title="Report Filters"
      >
        <div class="d-block text-left">
          <b-form-group id="Invoice" label="Invoice Numbers">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedInvoiceArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="invoiceNumbersArray"
            />
          </b-form-group>
          <b-form-group id="Account" label="Account">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedaccArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="accNumbersArray"
            />
          </b-form-group>
          <b-form-group id="Licensor" label="Licensor">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedLicensorArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="licensorArray"
            />
          </b-form-group>
          <!-- <b-form-group label="Invoice Date Range">
            <flat-pickr
              :config="{ mode: 'range', ...$flatPickrConfig }"
              placeholder="Select"
              class="form-control"
              v-model="filters.selectedInvDateRange"
            />
          </b-form-group> -->
          <b-form-group id="Currency" label="Currency">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedCurrencyArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="currencyArray"
            />
          </b-form-group>
        </div>

        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="onApplyFilters"
          >Apply Filters</b-button
        >
        <b-button variant="outline-info" block @click="onResetFilters"
          >Reset Filters</b-button
        >
      </b-modal>
    </div>
    <b-modal v-if="invId" size="xl" id="invModal" title="Invoice"
      ><preview-invoice :invId="invId" />
    </b-modal>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  VBTooltip,
  BFormGroup,
  BBadge,
  BAlert,
} from "bootstrap-vue";
import { GetAccountReceivableReport } from "@/apiServices/BookkeepingServices";
import moment from "moment";
import { formatCurrency, formatExchangeRate } from "@/utils/helpers";
import qs from "qs";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import PreviewInvoice from "@/views/pages/Revenue/PreviewInvoice.vue";
import { fill } from "lodash";

export default {
  data() {
    return {
      reportDateRange: null,
      reportFromDate: null,
      reportToDate: null,
      invoiceNumbersArray: [],
      accNumbersArray: [],
      licensorArray: [],
      currencyArray: [],
      showTotal: true,
      filters: {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedLicensorArray: [],
        selectedCurrencyArray: [],
        selectedInvDateRange: null,
        show_paid_invoice:false,
      },
      appliedFilters: {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedLicensorArray: [],
        selectedInvDateRange: null,
        selectedCurrencyArray: [],
      },
      BASE_URL: process.env.VUE_APP_BASEURL,
      moment: moment,
      tabIndex: 0,
      accountReceivableReportData: [],
      actualAccountReceivableReportData: [],
      filterApplied: false,
      invId: null,
      applyFilterClicked:false,
    };
  },
  mounted() {
    this.loadAccountRecievableFilters();
  },
  computed: {
    // this.loadFilters(),
    // },
    filteredAccountReceivableReportData() {
      return this.accountReceivableReportData.filter(
        (item) => this.showTotal || item.invoice_unique_id !== "Total"
      );
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BTabs,
    BTab,
    BCard,
    FeatherIcon,
    BButton,
    VBTooltip,
    vSelect,
    BFormGroup,
    flatPickr,
    BBadge,
    PreviewInvoice,
    BAlert,
  },
  beforeMount() {
    this.filterApplied = false;
    this.reportToDate = moment().format("YYYY-MM-DD");
    this.getAccountReceivableReport();
  },
  methods: {
    formatCurrency,
    formatExchangeRate,
    handleResetButtonClicked() {
      console.log("Reset button is clicked");
      localStorage.removeItem("accountReceivableFilters");
      localStorage.removeItem("accountReceivableDateSelected");
      this.filterApplied = false;
      this.reportToDate = moment().format("YYYY-MM-DD");
      this.filters = {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedLicensorArray: [],
        selectedCurrencyArray: [],
        selectedInvDateRange: null,
      };
      this.invoiceNumbersArray = [];
      this.accNumbersArray = [];
      this.licensorArray = [];  
      this.currencyArray = [];  
      this.show_paid_invoice = false;
      this.getAccountReceivableReport();
    },
    onReportDate() {
      // if (this.reportDateRange) {
      //   let from = null;
      //   let to = null;
      //   if (this.reportDateRange.split("to").length > 1) {
      //     from = new Date(this.reportDateRange.split("to")[0]);
      //     to = new Date(this.reportDateRange.split("to")[1]);
      //   } else {
      //     from = new Date(this.reportDateRange.split("to")[0]);
      //     to = new Date(this.reportDateRange.split("to")[0]);
      //   }

      //   this.reportFromDate = `${from.getFullYear()}-${(
      //     "0" +
      //     (from.getMonth() + 1)
      //   ).slice(-2)}-${("0" + from.getDate()).slice(-2)}`;

      //   this.reportToDate = `${to.getFullYear()}-${(
      //     "0" +
      //     (to.getMonth() + 1)
      //   ).slice(-2)}-${(
      //     "0" + (to.getDate() + to.getMonth() == 2 ? 28 : 30)
      //   ).slice(-2)}`;
      localStorage.setItem(
        "accountReceivableDateSelected",
        JSON.stringify(this.reportToDate)
      );
      this.invoiceNumbersArray = [];
      this.accNumbersArray = [];
      this.licensorArray = [];
      this.currencyArray = [];
      this.getAccountReceivableReport();
      // }

      //       const parsedDate = moment(dateString, 'MMM-YYYY');

      // // Step 2: Format the parsed date into YYYY-MM-DD format
      // const formattedDate = parsedDate.format('YYYY-MM-DD');
    },
    onExportExcel() {
      let url = null;
      let excelName = "";
      let payload = {
        accountReceivableReportData: this.accountReceivableReportData,
        invNumbers: this.filters.selectedInvoiceArray
          ? this.filters.selectedInvoiceArray.toString()
          : "",
        accNumber: this.filters.selectedaccArray
          ? this.filters.selectedaccArray.toString()
          : "",

        licensor: this.filters.selectedLicensorArray
          ? this.filters.selectedLicensorArray.toString()
          : "",
        invDtRange: this.filters.selectedInvDateRange,
        currency: this.filters.selectedCurrencyArray
          ? this.filters.selectedCurrencyArray.toString()
          : "",
      };

      url = this.BASE_URL + `/bookkeeping/exportAccountReceivableReport`;

      fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/Json",
          authorization: localStorage.getItem("access_token"),
          "x-access-token": localStorage.getItem("access_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const anchorElement = document.createElement("a");
          document.body.appendChild(anchorElement);
          anchorElement.style.display = "none";
          excelName = "Account_Recievable_Report.xlsx";
          var url = window.URL.createObjectURL(blob);
          anchorElement.href = url;
          anchorElement.download = excelName;
          anchorElement.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err, "error in onExportExcel");
        });
    },
    async getAccountReceivableReport() {
      try {
        this.accountReceivableReportData = [];
        this.actualAccountReceivableReportData = [];
        this.loadAccountRecievableFilters() ;
        const response = await GetAccountReceivableReport({
          //  reportFromDate: this.reportFromDate,
          filters: this.filters,
          reportToDate: this.reportToDate,
        });
        if (response.data.status) {
          this.actualAccountReceivableReportData = response.data.data;
          this.accountReceivableReportData = response.data.data;
          let addedInv = [];
          let addedLicensor = [];
          let addedCurrency = [];
          let addedAcc = [];
          for (let item of this.accountReceivableReportData) {
            if (
              item.invoice_unique_id &&
              item.invoice_unique_id != "Total" &&
              item.invoice_unique_id != "Grand Total"
            ) {
              if (!addedInv.includes(item.invoice_unique_id)) {
                let obj = {
                  id: item.invoice_unique_id,
                  value: item.invoice_unique_id,
                };
                const isDuplicateInvoiceNumbers = this.invoiceNumbersArray.some(
                  (existingItem) => existingItem.id === item.invoice_unique_id
                );

                if (!isDuplicateInvoiceNumbers) {
                  this.invoiceNumbersArray.push(obj);
                  addedInv.push(item.invoice_unique_id);
                }

              }

              if (!addedAcc.includes(item.iban)) {
                let obj66 = {
                  id: item.iban,
                  value: item.iban,
                };
                // this.accNumbersArray.push(obj66);
                // addedAcc.push(item.iban);
                const isDuplicateAccountArray = this.accNumbersArray.some(
                  (existingItem) => existingItem.id === item.iban
                );

                if (!isDuplicateAccountArray) {
                  this.accNumbersArray.push(obj66);
                  addedAcc.push(item.iban);
                }
              }

              if (!addedLicensor.includes(item.company)) {
                let obj1 = {
                  id: item.company,
                  value: item.company,
                };
                const isDuplicateLicensorArray = this.licensorArray.some(
                  (existingItem) => existingItem.id === item.company
                );

                if (!isDuplicateLicensorArray) {
                  this.licensorArray.push(obj1);
                  addedLicensor.push(item.company);
                }

              }
              if (item.selectedCurrency) {
                if (!addedCurrency.includes(item.selectedCurrency)) {
                  let obj2 = {
                    id: item.selectedCurrency,
                    value: item.selectedCurrency,
                  };

                  const isDuplicateCurrency = this.currencyArray.some(
                  (existingItem) => existingItem.id === item.selectedCurrency
                );

                if (!isDuplicateCurrency) {
                  this.currencyArray.push(obj2);
                  addedLicensor.push(item.selectedCurrency);
                }
                }
              }

            }
          }
        }
        console.log(response, "response");
      } catch (error) {
        console.log("Error in getAccountReceivableReport", error);
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    onResetFilters() {
      this.filterApplied = false;
      localStorage.removeItem("accountReceivableFilters");
      localStorage.removeItem("accountReceivableDateSelected");
      this.invoiceNumbersArray = [];
      this.accNumbersArray = [];
      this.licensorArray = [];
      this.currencyArray = [];
      this.filters = {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedLicensorArray: [],
        selectedCurrencyArray: [],
        selectedInvDateRange: null,
      };
      this.getAccountReceivableReport();
    },
    loadAccountRecievableFilters() {
      let customSelectionFilters = localStorage.getItem(
        "accountReceivableFilters"
      );
      if (customSelectionFilters) {
        let parsedSelectionFilters = JSON.parse(customSelectionFilters);
        console.log(
          parsedSelectionFilters,
          "value of custom filters set in local storage"
        );
        this.filters = parsedSelectionFilters;
        this.appliedFilters = parsedSelectionFilters;
        if(this.filters.selectedInvoiceArray.length > 0 || this.filters.selectedaccArray.length > 0 || this.filters.selectedLicensorArray > 0 || this.filters.selectedCurrencyArray > 0  ){
           this.filterApplied = true ;
        }
        console.log(this.appliedFilters,'filters fetched from local storage')  ;
      }
      let dateRangeFilters = localStorage.getItem(
        "accountReceivableDateSelected"
      );
      if (dateRangeFilters) {
        let parsedSelectionDateRangeFilters = JSON.parse(dateRangeFilters);
        console.log(
          parsedSelectionDateRangeFilters,
          "value of date range filters set in local storage"
        );
        this.reportToDate = parsedSelectionDateRangeFilters;
        console.log(this.reportDateRange,'filters fetched from local storage')  ;
      }
    },
    onApplyFilters() {
      this.filterApplied = true;
      this.applyFilterClicked = true;
      this.appliedFilters = JSON.parse(JSON.stringify(this.filters));
      localStorage.setItem(
        "accountReceivableFilters",
        JSON.stringify(this.appliedFilters)
      );
      this.getAccountReceivableReport();
      this.$refs["my-modal"].hide();
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-outline-primary", "text-info"];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  color: #000;
  border: 2px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-weight: 400;
}
tr:hover {
  background-color: yellow;
}
</style>
